import { FaCheck, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { AppButton } from '../Button/_index';

const BLOCK = 'LStudio__app_wizard';

export const AppWizard = ({
    steps = [], currentStep = 0, maxVisitedStep = currentStep,
    onStepChange = null, onBack = null, onNext = null, onComplete = null,
    children, title = '', description = '',
    backLabel = 'Anterior', nextLabel = 'Siguiente', completeLabel = 'Finalizar',
    disableBack = false, disableNext = false, showActions = true,
    allowVisitedNavigation = true,
}) => {
    const safeCurrentStep = Math.min(Math.max(Number(currentStep) || 0, 0), Math.max(steps.length - 1, 0));
    const activeStep = steps[safeCurrentStep] ?? null;
    const isFirstStep = safeCurrentStep <= 0;
    const isLastStep = safeCurrentStep >= Math.max(steps.length - 1, 0);
    const progress = steps.length > 0 ? Math.round(((safeCurrentStep + 1) / steps.length) * 100) : 0;

    const onSelectStep = (index) => {
        const canOpen = allowVisitedNavigation && index <= maxVisitedStep && index !== safeCurrentStep;
        if (canOpen) onStepChange?.(index);
    };

    return (
        <section className={BLOCK}>
            {(title || description) && (
                <header className={`${BLOCK}__intro`}>
                    {title && <h2>{title}</h2>}
                    {description && <p>{description}</p>}
                </header>
            )}

            <div className={`${BLOCK}__progress`}>
                <div className={`${BLOCK}__progress_meta`}>
                    <span>Paso {steps.length ? safeCurrentStep + 1 : 0} de {steps.length}</span>
                    <strong>{progress}%</strong>
                </div>
                <div className={`${BLOCK}__progress_track`} aria-hidden="true">
                    <span style={{ width: `${progress}%` }} />
                </div>
            </div>

            <nav className={`${BLOCK}__steps`} aria-label="Pasos del asistente">
                {steps.map((step, index) => {
                    const isActive = index === safeCurrentStep;
                    const isDone = index < safeCurrentStep;
                    const isVisited = index <= maxVisitedStep;
                    const canOpen = allowVisitedNavigation && isVisited && !isActive && Boolean(onStepChange);

                    return (
                        <button
                            key={step.id ?? index}
                            type="button"
                            className={`${BLOCK}__step`}
                            data-active={isActive}
                            data-done={isDone}
                            data-visited={isVisited}
                            disabled={!canOpen}
                            onClick={() => onSelectStep(index)}
                            aria-current={isActive ? 'step' : undefined}
                        >
                            <span className={`${BLOCK}__step_index`}>{isDone ? <FaCheck /> : index + 1}</span>
                            <span className={`${BLOCK}__step_text`}>
                                <small>{step.shortLabel ?? `Paso ${index + 1}`}</small>
                                <strong>{step.title ?? `Paso ${index + 1}`}</strong>
                                {step.description && <span>{step.description}</span>}
                            </span>
                        </button>
                    );
                })}
            </nav>

            <div className={`${BLOCK}__content`}>
                {activeStep && (
                    <header className={`${BLOCK}__content_header`}>
                        <span>{activeStep.eyebrow ?? `Paso ${safeCurrentStep + 1}`}</span>
                        <h3>{activeStep.title}</h3>
                        {activeStep.description && <p>{activeStep.description}</p>}
                    </header>
                )}
                <div className={`${BLOCK}__body`}>{children}</div>
            </div>

            {showActions && steps.length > 0 && (
                <footer className={`${BLOCK}__actions`}>
                    <AppButton
                        type="button"
                        variant="outline"
                        disabled={isFirstStep || disableBack}
                        onClick={onBack}
                    >
                        <FaChevronLeft /> {backLabel}
                    </AppButton>
                    <div className={`${BLOCK}__actions_right`}>
                        {!isLastStep ? (
                            <AppButton type="button" disabled={disableNext} onClick={onNext}>
                                {nextLabel} <FaChevronRight />
                            </AppButton>
                        ) : (
                            <AppButton type="button" disabled={disableNext} onClick={onComplete}>
                                <FaCheck /> {completeLabel}
                            </AppButton>
                        )}
                    </div>
                </footer>
            )}
        </section>
    );
};
